export enum DevBudgetCalculationMethods {
  "total" = "total",
  "% of total" = "% of total",
  "per sf" = "per sf",
  "per unit" = "per unit",
}
